import React from 'react';
import { ContributionProfitInfo, LiquidationCOGSInfo, LiquidationRevenueInfo, VariableFCCostsInfo } from './accuracy_benchmark_info';
import { Badges, KeyOriginalMapping } from './mapper';

const isIgnored = (item, cognosAccount) => {
  if (item.type !== 'Cognos') {
    return false;
  }

  if (!cognosAccount) {
    return true;
  }

  return item.ignored;
};

const getSign = (text) => {
  let sign = '';
  if (text === '-') {
    sign = '(-)';
  }
  return sign;
};

export const prepareListItem = (map, hideType, change, cognosAccountMap, badges) => {
  let type = hideType === true ? '' : map.type + '-';
  const cognosAccount = cognosAccountMap[map.value];
  const { label, excluded, comment } = cognosAccount
    ? cognosAccount
    : { label: map.value, excluded: false, comment: '' };

  const ignored = isIgnored(map, cognosAccount);

  let item = <span>{getSign(map.operation) + type + label} </span>;
  if (change === 'mappingDeleted') {
    item = <del>{item}</del>;
  } else if (change !== 'none') {
    item = badges[change](item);
  }
  return (
    <td style={{ color: ignored ? 'red' : '' }}>
      {item}
      {excluded && badges['Excluded'](comment)}
      {ignored && badges['Ignored'](comment)}
    </td>
  );
};

export const toDisplayDate = (dateString) => {
  return isNaN(dateString) ? dateString : new Date(dateString + ' UTC').toLocaleString();
};

export const getBenchmarkConfigDiffView = (stagedItem, item, key) => {
  const formattedValue = getFormattedBenchmarkConfiguration(item, key);
  const stagedFormattedValue = getFormattedBenchmarkConfiguration(stagedItem, KeyOriginalMapping[key]);
  if(stagedItem.change &&
    (stagedItem[KeyOriginalMapping[key]] !== null || stagedItem[KeyOriginalMapping[key]] === null && item[key] !== null) &&
    stagedFormattedValue !== formattedValue){
    return (
      <span key="deleted">
        <del> {stagedFormattedValue} </del>
        { '  ' }
        {Badges[stagedItem.change](getFormattedBenchmarkConfiguration(item, key))}
    </span>);
  }
  return formattedValue;
}

export const getFormattedBenchmarkConfiguration = (item, key) => {
  if (key === 'baseFactor' || key === 'originalBaseFactor'){
    return item[key] ? HCP_DRIVER_NAME[item[key]] : 'N/A';
  } else if (key === 'reallocationGrain' || key === 'originalReallocationGrain'){
    return item[key] ? REALLOCATION_GRAIN[item[key]] : REALLOCATION_GRAIN.NONE;
  } else if (key === 'subcomponentRollup' || key === 'originalSubcomponentRollup'){
    return item[key] ? 'Yes' : 'No';
  } else if (key === 'comment' || key === 'originalComment') {
    return item[key] || 'N/A';
  }
};

export const HCP_DRIVER_NAME = {
  product_gms: 'Product GMS',
  units: 'Units',
  product_cogs: 'Product COGS',
  shipping_cost: 'Shipping Cost',
  variable_fc :  'Variable FC Cost',
  product_cogs_vendor_exclusions: 'Product COGS - Vendor Returned Exclusions',
  liquidation_cogs_benchmark: 'Liquidation COGS Benchmark',
};

export const HCP_DRIVER_DROPDOWN_ELEMENTS = [
  {
    label: 'N/A',
    value: null,
  },
  {
    label: HCP_DRIVER_NAME['product_gms'],
    value: 'product_gms',
  },
  {
    label: HCP_DRIVER_NAME['units'],
    value: 'units',
  },
  {
    label: HCP_DRIVER_NAME['product_cogs'],
    value: 'product_cogs',
  },
  {
    label: HCP_DRIVER_NAME['shipping_cost'],
    value: 'shipping_cost',
  },
  {
      label: HCP_DRIVER_NAME['variable_fc'],
      value: 'variable_fc',
    }
];

export const REALLOCATION_GRAIN = {
  NONE: 'Default (Marketplace/Channel/GL)',
  MARKETPLACE: 'Marketplace',
  MARKETPLACE_AND_CHANNEL: 'Marketplace/Channel',
  T12M_MARKETPLACE_AND_CHANNEL_AND_GL: 'T12M Marketplace/Channel/GL',
  T12M_SIMPLE_AVG_MARKETPLACE_AND_CHANNEL_AND_GL: 'T12M Simple Avg Marketplace/Channel/GL',
  PRODUCT_FAMILY: 'Parent Product Family',
};

export const REALLOCATION_GRAIN_DROPDOWN_ELEMENTS = [
  {
    label: REALLOCATION_GRAIN.NONE,
    value: 'NONE',
  },
  {
    label: REALLOCATION_GRAIN.MARKETPLACE,
    value: 'MARKETPLACE',
  },
  {
    label: REALLOCATION_GRAIN.MARKETPLACE_AND_CHANNEL,
    value: 'MARKETPLACE_AND_CHANNEL',
  },
  {
    label: REALLOCATION_GRAIN.T12M_SIMPLE_AVG_MARKETPLACE_AND_CHANNEL_AND_GL,
    value: 'T12M_SIMPLE_AVG_MARKETPLACE_AND_CHANNEL_AND_GL',
  },
  {
    label: REALLOCATION_GRAIN.PRODUCT_FAMILY,
    value: 'PRODUCT_FAMILY',
  },
];

export const REALLOCATION_GRAIN_LIQUIDATIONS = [
  {
    label: REALLOCATION_GRAIN.T12M_MARKETPLACE_AND_CHANNEL_AND_GL,
    value: 'T12M_MARKETPLACE_AND_CHANNEL_AND_GL',
  }
];

export const HCP_DRIVER_LIQUIDATIONS = [
  {
    label: HCP_DRIVER_NAME['product_cogs_vendor_exclusions'],
    value: 'product_cogs_vendor_exclusions',
  },
  {
    label: HCP_DRIVER_NAME['liquidation_cogs_benchmark'],
    value: 'liquidation_cogs_benchmark',
  }
];

export const LIQUIDATION_COMPONENTS = ['Liquidation COGS', 'Liquidation Revenue', 'Damages', 'Disposed', 'Overstock'];

export const BOOLEAN_DROPDOWN_ELEMENTS = [
  {
    label: 'True',
    value: true,
  },
  {
    label: 'False',
    value: false,
  }
];

export const TAX_ADJUSTMENTS_COMPONENT = ['Product COGS'];

export const CONTRIBUTION_PROFIT_COMPONENT = ['Contribution Profit'];

export const HELP_PANEL_INFOS = {
  'Liquidation Revenue': <LiquidationRevenueInfo />,
  'Liquidation COGS': <LiquidationCOGSInfo />,
  'Variable FC Costs': <VariableFCCostsInfo />,
  'Contribution Profit': <ContributionProfitInfo />,
};

export const ACCURACY_BENCHMARK_HELP_PANEL_COMPONENTS = ['Liquidation COGS', 'Liquidation Revenue'];

export const CP_COLUMN_HELP_PANEL_COMPONENTS = ['Variable FC Costs', 'Contribution Profit'];



// WEBPACK FOOTER //
// ./src/components/mapper/utils.jsx